import { makeContractPaymentsRepository } from 'modules/customer/infra/repositories';

import { CreateCardPendencyPaymentUseCase } from './implementations/CreateCardPendencyPaymentUseCase';

let instance: CreateCardPendencyPaymentUseCase | null = null;

export default function makeCreateCardPendencyPaymentUseCase() {
  if (!instance) {
    const repository = makeContractPaymentsRepository();

    instance = new CreateCardPendencyPaymentUseCase(repository);
  }

  return instance;
}
